import { For, createSignal } from "solid-js";
import { render } from "solid-js/web";

import "./Message.css";

// 标记是否已经挂载
let isMounted = false;
// 外部调用插入消息的函数引用
let pushMessage: ((text: string) => void) | null = null;

// 挂载 MessageCenter 到 body
function mountMessageCenter() {
  if (isMounted) return;

  const mountPoint = document.createElement("div");
  document.body.appendChild(mountPoint);

  render(() => <MessageCenter />, mountPoint);

  isMounted = true;
}

// 外部调用：显示消息
function show(text: string) {
  mountMessageCenter();
  pushMessage?.(text);
}

// 导出 API
export const message = {
  show,
};

// UI 组件（内部）
function MessageCenter() {
  const [messages, setMessages] = createSignal<{ id: number; text: string }[]>(
    [],
  );

  pushMessage = (text: string) => {
    const id = Date.now() + Math.random();

    setMessages((prev) => {
      const next = [...prev, { id, text }];
      return next.length > 3 ? next.slice(-3) : next;
    });

    setTimeout(() => {
      setMessages((prev) => prev.filter((m) => m.id !== id));
    }, 3000);
  };

  return (
    <div class="message-center">
      <For each={messages()}>
        {(msg) => (
          <div
            class="message-item"
            onClick={() =>
              setMessages((prev) => prev.filter((m) => m.id !== msg.id))
            }
          >
            {msg.text}
          </div>
        )}
      </For>
    </div>
  );
}
